import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import autoImage from "../../assets/images/promo-auto.webp";

const useOnScreen = (ref, threshold = 0.1) => {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIntersecting(entry.isIntersecting),
      { threshold }
    );

    const current = ref.current;
    if (current) observer.observe(current);

    return () => {
      if (current) observer.unobserve(current);
    };
  }, [ref, threshold]);

  return isIntersecting;
};

const AutoInsurancePromo = () => {
  const sectionRef = useRef(null);
  const isVisible = useOnScreen(sectionRef);

  return (
    <section
      ref={sectionRef}
      className={`py-16 transition-all duration-1000 ease-in-out ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center md:gap-x-12 lg:pl-24">
          {/* Texto à esquerda */}
          <div className="md:w-1/2 mb-10 md:mb-0">
            <h2 className="text-3xl sm:text-4xl font-bold text-blue-950 mb-4">
              100% ONLINE - Economize <br />
              tempo e dinheiro!
            </h2>
            <p className="text-lg sm:text-xl text-blue-950 mb-12">
              <span className="font-bold">Chega de burocracia!</span> Contrate seu seguro auto de forma <span className="font-bold">simples</span> e
              <span className="font-bold"> online</span>. Compare opções de 16 seguradoras e escolha a <span className="font-bold">melhor
              proteção</span> para o  <span className="font-bold">seu carro</span> — tudo em poucos cliques.
            </p>
            <Link
              to="/auto"
              className="bg-blue-800 hover:bg-blue-950 text-white px-6 py-3 rounded-md font-medium inline-block"
            >
              Quero contratar
            </Link>
          </div>

          {/* Imagem à direita */}
          <div className="md:w-1/3">
            <img
              src={autoImage}
              alt="Seguro auto online"
              className="rounded-3xl shadow-lg w-full h-auto object-contain"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AutoInsurancePromo;
